import { useQuery } from "@tanstack/react-query";
import { schoolService } from "../../../services";
import type { School, SchoolFilters } from "../../../modules/school/types";

export interface UseSchoolsParams {
  filters?: SchoolFilters;
  page?: number;
  per_page?: number;
  enabled?: boolean;
}

export const useSchools = (params: UseSchoolsParams = {}) => {
  const { filters = {}, page, per_page, enabled = true } = params;
  
  return useQuery({
    queryKey: ["schools", filters, { page, per_page }],
    queryFn: () => schoolService.getSchools({ ...filters, page, per_page }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    select: (data) => data.data || [],
    enabled,
  });
};

/** Tên trường của lớp; chỉ gọi API trường khi lớp chưa kèm sẵn tên. Cùng query key với trang chi tiết trường. */
export const useSchoolName = (schoolId?: string, embeddedName?: string) => {
  const query = useQuery({
    queryKey: ["school", schoolId],
    queryFn: () => schoolService.getSchool(schoolId as string),
    enabled: !!schoolId && !embeddedName,
    staleTime: 5 * 60 * 1000,
  });
  return { name: embeddedName || query.data?.name, isLoading: query.isLoading };
};

export type { School, SchoolFilters };
